import { Component, OnInit, Input, OnChanges, EventEmitter, Output } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { PageService } from '../../../shared/components/page/page.service';
import { BaseHttpService } from '../../../shared/services/basehttp.service';
import { Constants } from '../../../shared/constants';
import { NotificationService } from '../../../shared/services/notifications.service';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { CardService } from "../../../shared/components/view/card/card.service";
import { PageAdapter } from '../../../shared/components/page/page.adapter';
import { ModalSize } from '../../../shared/components/view/modal/modal.model';
import { ButtonSize, ButtonStyle, ButtonType, ButtonColors } from '../../../shared/components/inputs/button/button.model';
import { CreateSurvey, SurveyAdmins, QuestionAnswer, Question, OptionsInfo, QuestionType, ValidationData, SelectedQuestionData, qTypes, GridQuestion, SubQuestion } from './page.model';
import { ParamService } from '../../../shared/services/param.service';
import { MatDrawer } from '@angular/material/sidenav';
import { v4 as uuidv4 } from 'uuid';

import {
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
  faWrench,
  faImage,
  faEllipsisH,
  faClone,
  faTrash,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { trigger, transition, style, animate } from '@angular/animations';
import { GlobalsessionhandlerService } from '../../services/globalsessionhandler.service';
import { UserActivityLogModel } from '../../models/userActivityLog.model';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('1s ease-in', style({ opacity: '1' })),
      ]),
      transition(':leave', [
        style({ opacity: '1' }),
        animate('2s ease-out', style({ opacity: '0' })),
      ])
    ]),
  ],
  standalone: false
})

//export class PageComponent implements OnInit, OnChanges {
export class PageComponent implements OnInit {
  constant: Constants = new Constants();
  queAns: QuestionAnswer[] = [];
  gridQuestions:GridQuestion[]=[];
  queTypes: QuestionType[] = qTypes;
  matrixQuesTypes=qTypes.filter(x=>x.type=='radiobuttons' || x.type=='checkbox'||x.type=='multipleChoice');
  surveyDetails: CreateSurvey;
  esignConsenttext:string="";
  rowType:string='radiobuttons';
  icons = {
    faChevronDown: faChevronDown,
    faChevronUp: faChevronUp,
    faPlus: faPlus,
    faMinus: faMinus,
    faWrench: faWrench,
    faImage: faImage,
    faEllipsisH: faEllipsisH,
    faClone: faClone,
    faTrash: faTrash,
    faTimes: faTimes
  };
  selectedQuestion: QuestionType;
  isAddQuestion: boolean = false;
  public imagePath;
  imgURL: any = [];
  public message: string;
  ;
  @Input() isSettingPanelOpened:boolean=false;
  @Input() pageData: QuestionAnswer[] = [];
  @Input() isEditing: boolean = false;
  @Input() nrSelectQues: string = "Invalid";
  @Input() nrSelectPreQues: string;
  @Input() positionValueQuestions: QuestionAnswer[] = [];
  @Output() public hidepopupevent = new EventEmitter();
  quesSel: number = 999;
  quesSelPre: number = 999;
  quesFinal: Question = new Question("", "", "","",0);
  public selectedDataChild: SelectedQuestionData = {isSettingPanelOpened:false, selectedCard: null, selectedSection:null, questions: null,isSectionSelected:false };

  isQueExpanded: boolean = false;
  @Output() outputToSettingPanel: EventEmitter<any>=new EventEmitter();
  @Output() outputToParent: EventEmitter<SelectedQuestionData> = new EventEmitter<SelectedQuestionData>();
  @Input() SurveyId: string = "";
  @Input() SurveyName: string = "";
  @Input() currPage: number = 0;
  modalSize = ModalSize.Small;
  modalText = "Draft";
  hidePopUp: boolean = true;
  btnText = "CONTINUE";
  btnDuplicateText="Duplicate"
  btnMedium = ButtonSize.Medium;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  btnBlue = ButtonColors.Blue;
  btncloseText = "CLOSE";
  questionNumbersIncrement: number = 0;
  isEditmode: boolean;
  param: string;
  IsQuestionMenu:boolean;
  IsGridQuestionMenu:boolean;
  IsESignQuesTypeAdded:boolean=false;
  constructor(private data: PageService,private globalSession: GlobalsessionhandlerService, private baseHttpService: BaseHttpService, private notificationService: NotificationService, private router: Router, private cardservice: CardService, private pageadapter: PageAdapter, private paramservice: ParamService) { }

  DuplicateSection(queAns:QuestionAnswer[],card:QuestionAnswer)
  {
    let cloneQuestionAnswer: QuestionAnswer;
    let ques:Question[]=[]
    card.questions.forEach(data=>{
        qTypes.forEach(x=>{
        if( x.type==data.dataType)
        {
          this.setQuestionContent(x);
          this.questionNumbersIncrement = this.questionNumbersIncrement + 1;
          ques.push(
            new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type,this.guid(),this.questionNumbersIncrement)
          );
          return ;
        }
        })
      });

      let seq=1;
      if(this.queAns && this.queAns.length>0)
      {
      let sorted=this.queAns.sort((a,b)=>a.sequenceNumber-b.sequenceNumber);
      seq=sorted[sorted.length-1].sequenceNumber+1;
      }
      cloneQuestionAnswer=new QuestionAnswer("",ques,this.guid(),seq);
      cloneQuestionAnswer.questions=ques;

      queAns.push(
        cloneQuestionAnswer
     );


     this.data.changeMessage(queAns);
     let survey = this.TempStoreData();
     this.cardservice.tempholdSurveyData(survey);


  }

  ngOnInit() {
    
    this.paramservice.currentMessage.subscribe((message: "") => this.param = message)
    if (this.param === "CREATE") {
      this.paramservice.Parameterpass("");
      this.cardservice.tempholdSurveyData(new CreateSurvey());
    }

    //Edit Survey Service
    this.isEditmode = false;
    this.cardservice.currentMessage.subscribe((message: CreateSurvey) => this.surveyDetails = message)
    let editSurveyList = this.surveyDetails;

    // this.cardservice.getSurveyDetails(new CreateSurvey());
    this.data.changeMessage([]);
    if (editSurveyList.surveyId != "" && editSurveyList.surveyId != null) {
      this.cardservice.tempholdSurveyData(this.surveyDetails);
      this.SurveyId = editSurveyList.surveyId;
      this.SurveyName = editSurveyList.name;
      let surveylist = editSurveyList["sections"];
      if (surveylist === null) {
        surveylist = [];
      }
      this.queAns = surveylist;


      if (this.queAns != null) {
        this.queAns.forEach((obj, index) => {

          if (obj.questions != null) {


            if(obj.gridQuestions==null)
            {
              obj.gridQuestions=[];
            }

            obj.gridQuestions.forEach(gridObj=>{
              gridObj.questions.forEach((obj, index) => {
              obj.dataType = this.pageadapter.getInputTypeonEdit(obj.inputType);
              obj.questionImage = "data:image/jpg;base64," + obj.questionImage;
              //obj.inputType = null;
 	             if (obj.parentQuesResponse == "") {
                obj["isParentQuestionVisible"] = true;
              }
              else {
                obj["isParentQuestionVisible"] = false;
              }
              this.questionNumbersIncrement = this.questionNumbersIncrement + 1;
            });
            gridObj.questions.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
          });

            obj.questions.forEach((obj, index) => {

              obj.dataType = this.pageadapter.getInputTypeonEdit(obj.inputType);
              obj.questionImage = "data:image/jpg;base64," + obj.questionImage;
              //obj.inputType = null;
      	      if (obj.parentQuesResponse == "") {
                obj["isParentQuestionVisible"] = true;
              }
              else {
                obj["isParentQuestionVisible"] = false;
              }
              this.questionNumbersIncrement = this.questionNumbersIncrement + 1;
              obj.subQuestions.forEach(x=>{
                x.dataType=this.pageadapter.getInputTypeonEdit(x.inputType);
                x.questionImage= "data:image/jpg;base64," + x.questionImage;
                if (x.parentQuesResponse == "") {
                  x["isParentQuestionVisible"] = true;
                }
                else {
                  x["isParentQuestionVisible"] = false;
                }
              });
            });


          }
        });
        this.data.changeMessage([]);
        this.updateData();

      }

      this.hidepopupevent.emit(true);
      this.isEditmode = true;
      let templatesurvey = new CreateSurvey();
      templatesurvey.surveyId = this.SurveyId;
      this.cardservice.templatesurveydata(templatesurvey);
    }

    this.queTypes.forEach(element => {
      {
        let splitted = element.title ? element.title.split(" ", 2) : '';
        if (splitted.length > 1) {
          element.icon = splitted[0].substr(0, 1) + splitted[1].substr(0, 1);
        }
        else {
          element.icon = element.title.substr(0, 2);
        }
      }
    });

    //Store temp data
    this.cardservice.tempdatacurrentMessage.subscribe((message: CreateSurvey) => this.surveyDetails = message)
    let templist = this.surveyDetails;
    this.SurveyId = templist.surveyId;
    this.SurveyName = templist.name;
    let surveylist = templist["sections"];
    if (surveylist === null || surveylist === undefined) {
      surveylist = [];
    }
    this.queAns = surveylist;
    if (templist.surveyId != "" && templist.surveyId != null) {
      this.hidepopupevent.emit(true);
      if (this.queAns != null) {
        this.data.changeMessage([]);
        this.updateData();
      }
    }
    this.esignConsenttext=editSurveyList.eSignConsentText;
    this.IncludeEsignConsent();
  }

  isQuestionType(obj: any): obj is Question { return obj.questionTextShort !== undefined; }


   expandSectionCard(section: QuestionAnswer) {

    
    //section.parentQuestionGuid=this.queAns.filter(x=>x.sectionGuid==section.sectionGuid).map(y=>y.parentQuestionGuid)[0];
    //section.parentQuesResponse=this.queAns.filter(x=>x.sectionGuid==section.sectionGuid).map(y=>y.parentQuesResponse)[0];
    section.isExpanded = !section.isExpanded;
    this.isQueExpanded = !this.isQueExpanded;
      this.data.newEventVisible(section);
      this.selectedDataChild.isSectionSelected=true;
      this.selectedDataChild.selectedSection= section;
      this.selectedDataChild.questions = this.queAns;
      this.outputToParent.emit(this.selectedDataChild);
  }

  expandCard(card: (QuestionAnswer | Question),section:QuestionAnswer) {
    
    card.isExpanded = !card.isExpanded;
    this.isQueExpanded = !this.isQueExpanded;
    if (card instanceof Question || this.isQuestionType(card)) {
      this.data.newEventVisible(card);
      this.selectedDataChild.isSectionSelected=false;
      this.selectedDataChild.selectedCard = card;
      this.selectedDataChild.questions = this.queAns;
      if(section)
      {
        section.isExpanded=true;
        this.selectedDataChild.selectedSection=section;

      }
      this.outputToParent.emit(this.selectedDataChild);
    }
  }


  expandlessCard(card: (QuestionAnswer | Question)) {
    card.isExpanded = !card.isExpanded;
    this.isQueExpanded = !this.isQueExpanded;
    if (card instanceof Question || this.isQuestionType(card)) {
      this.data.newEventVisible(card);
      this.selectedDataChild.selectedCard = card;
      this.selectedDataChild.questions = this.queAns;
      this.outputToParent.emit(this.selectedDataChild);
    }
  }
  expandData(card: (QuestionAnswer | Question)) {

    if(card instanceof Question || card.isExpanded)
    {
    this.data.newEventVisible(card);
    }
    if (card instanceof Question) {
      this.selectedDataChild.selectedCard = card;
      this.selectedDataChild.questions = this.queAns;
      this.outputToParent.emit(this.selectedDataChild);
    }
  }


  GetQuestions(card:QuestionAnswer)
  {

    let lstQuesId=[];
    let lstGrid=card.gridQuestions.forEach(obj=>{
obj.questions.forEach(que=>
  {
       lstQuesId.push(que.questionId);
});
    });
    return card.questions.filter(x=>lstQuesId.indexOf(x.questionId)==-1);
  }
  toggleQuestionTypeGrid(card: (GridQuestion)) {
     if (!card.isMenuVisible) {
      this.outputToSettingPanel.emit();
      card.isMenuVisible = true;
      this.IsGridQuestionMenu=true;
    }
    else {
      card.isMenuVisible = false;
    }
    // this.outputToSettingPanel.emit();
    // card.isMenuVisible = true;
    //card.isExpanded=true;
  }

  toggleQuestionType(card: (QuestionAnswer)) {
    if (card.isExpanded && !card.isMenuVisible) {
      this.outputToSettingPanel.emit();
      card.isMenuVisible = true;
      this.IsQuestionMenu=true;
    }
    else {
      card.isMenuVisible = false;
    }

  }

  addNewSection(queAns: QuestionAnswer[]) {
    
    let seq=1;
    if(queAns && queAns.length>0)
    {
      let sorted=queAns.sort((a,b)=> (a.sequenceNumber-b.sequenceNumber));
      seq=sorted[sorted.length-1].sequenceNumber+1
    }
    queAns.push(
      new QuestionAnswer("",[],this.guid(),seq)
    );
    this.data.changeMessage(queAns);
    let survey = this.TempStoreData();
    this.cardservice.tempholdSurveyData(survey);


  }

  setQuestionContent(type: QuestionType) {
    this.selectedQuestion = type;
  }

  deleteGridQuestion(card:QuestionAnswer,gridId:Number,questionindex:Number)
  {
    this.data.changeMessage(this.queAns);
    let survey = this.TempStoreData();
    this.cardservice.tempholdSurveyData(survey);
    this.IncludeEsignConsent();

  }
  addNewColumnInGrid(questions:Question,card:QuestionAnswer,gridId:Number)
  {
    
    this.questionNumbersIncrement=1;// + 1;
    if(card.questions && card.questions.length>0)
    {
        let sorted=card.questions.sort((a,b)=> (a.sequenceNumber-b.sequenceNumber));
        this.questionNumbersIncrement = sorted[sorted.length-1].sequenceNumber+1;
    }
   
    let gridControl= new GridQuestion();
    gridControl=card.gridQuestions.filter(x=>x.gridId==gridId)[0];

    
    
    let selectdTye= this.selectedQuestion;
    gridControl.questions.push( new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type,this.guid(),this.questionNumbersIncrement))
    let ques=gridControl.questions[gridControl.questions.length-1];
    ques.sequenceNumber=gridControl.questions.length;
    qTypes.forEach(function(t){
      if(t.type==selectdTye.type)
      {
      ques.dataType=t.type;
      }
    });
    gridControl.isExpanded=false;
    gridControl.isMenuVisible=false;

    this.data.changeMessage(this.queAns);
    let survey = this.TempStoreData();
    this.cardservice.tempholdSurveyData(survey);
    this.IncludeEsignConsent();

  }

  IncludeEsignConsent()
  {

    if(this.queAns.filter(x=> (x.isDeleted==false || x.isDeleted==null) && x.questions.filter(x=> (x.inputType=='sign'||x.dataType=='signature') && (x.isDeleted==false || x.isDeleted==null)).length>0).length>0
    || (this.queAns.filter(x=> (x.isDeleted==false || x.isDeleted==null)
    && x.gridQuestions.length>0
    && x.gridQuestions.filter(x=> x.questions.filter(y=>
     (y.inputType=='sign'||y.dataType=='signature')
    && (y.isDeleted==false || y.isDeleted==null)).length>0).length>0)).length>0)
    {
      this.IsESignQuesTypeAdded=true;
    }
    else
    {
       this.IsESignQuesTypeAdded=false;
       this.esignConsenttext="";
    }
  }
  //   addNewQuestion(questions: Question[],card:QuestionAnswer) {

  //     
  //     this.questionNumbersIncrement=1;// + 1;

  //     if(card.questions && card.questions.length>0)
  //     {
  //       let sortedQues=card.questions.sort((a,b)=>(a.sequenceNumber-b.sequenceNumber));
  //       this.questionNumbersIncrement = sortedQues[sortedQues.length-1].sequenceNumber+1;
  //     }
    

  //     if(this.selectedQuestion.type=="table")
  //     {

  //         questions.push(
  //           new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type,this.guid(),this.questionNumbersIncrement)
  //         );

  //         let gridQues=new GridQuestion();
  //         gridQues.gridId=card.gridQuestions.length+1;
  //         gridQues.sequenceNumber= this.questionNumbersIncrement;
  //         gridQues.questions=[];
  //         card.gridQuestions.push(gridQues);//(new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type))
  //     }
  //     else{

  //         let  mainQue=this.guid();
  //         questions.push(
  //           new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type,this.guid(),this.questionNumbersIncrement)
  //         );
  // if(this.selectedQuestion.type=='matrix')
  //         {
  //           
  //           // let subQues=new SubQuestion();
  //           // subQues.questionGuid=mainQue;
  //            let queType=this.queTypes.find(x=>x.type=='radiobuttons');

  //           // subQues.subQuestion=
  //           let que=new Question("", queType.icon + (this.questionNumbersIncrement+1), queType.type,this.guid(),this.questionNumbersIncrement+1);
  //           let subQueMap= questions.find(x=>x.questionGuid==mainQue);
  //           if(subQueMap)
  //           {
  //             que.isExpanded=false;
  //             subQueMap.subQuestions=[];
  //             subQueMap.subQuestions.push(que);
  //           }
  //         }       this.IncludeEsignConsent();
  //     }

  //     this.data.changeMessage(this.queAns);
  //     let survey = this.TempStoreData();
  //     this.cardservice.tempholdSurveyData(survey);
  //   }

  addNewQuestion(questions: Question[],card:QuestionAnswer) {

    
    this.questionNumbersIncrement=1;// + 1;

    if(card.questions && card.questions.length>0)
    {
      let sortedQues=card.questions.sort((a,b)=>(a.sequenceNumber-b.sequenceNumber));
      this.questionNumbersIncrement = sortedQues[sortedQues.length-1].sequenceNumber+1;
    }


    if(this.selectedQuestion.type=="table")
    {

        questions.push(
          new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type,this.guid(),this.questionNumbersIncrement)
        );

        let gridQues=new GridQuestion();
        gridQues.gridId=card.gridQuestions.length+1;
        gridQues.sequenceNumber= this.questionNumbersIncrement;
        gridQues.questions=[];
        card.gridQuestions.push(gridQues);//(new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type))
    }
    else{

        let  mainQue=this.guid();
        questions.push(
          new Question("", this.selectedQuestion.icon + (this.questionNumbersIncrement), this.selectedQuestion.type,mainQue,this.questionNumbersIncrement)
        );
  if(this.selectedQuestion.type=='matrix')
        {
          
          // let subQues=new SubQuestion();
          // subQues.questionGuid=mainQue;
          let queType=this.queTypes.find(x=>x.type=='radiobuttons');

          // subQues.subQuestion=
          let que=new Question("", queType.icon + (this.questionNumbersIncrement+1), queType.type,this.guid(),this.questionNumbersIncrement+1);
          let subQueMap= questions.find(x=>x.questionGuid==mainQue);
          if(subQueMap)
          {
            que.isExpanded=false;
            subQueMap.subQuestions=[];
            subQueMap.subQuestions.push(que);
          }
        }       this.IncludeEsignConsent();
    }
    //card.isExpanded=false;    this.data.changeMessage(this.queAns);
    let survey = this.TempStoreData();
    this.cardservice.tempholdSurveyData(survey);
  }


  addOption(index: string, options: OptionsInfo[]) {
    
    let currentOptionIndex=parseInt(index)+1;
    options.forEach(x=>{
      if(x.sequenceNumber>currentOptionIndex)
      {
         x.sequenceNumber=x.sequenceNumber+1;
      }
    });

    options.push({
      key: index,
      value: '',
      sequenceNumber:currentOptionIndex+1
      //selected: false
    });

    options.sort((a,b)=>a.sequenceNumber-b.sequenceNumber);
    this.data.changeMessage(this.queAns);
  }

  removeOption(index: number, options: OptionsInfo[]) {
    options.forEach(x=>{
      if(x.sequenceNumber>index)
      {
         x.sequenceNumber=x.sequenceNumber-1;
      }
    })
    options.splice(index, 1);
    this.data.changeMessage(this.queAns);
  }

  deleteQuestion(index: number) {
    

    let sectionDeleted=this.queAns[index];
    if(sectionDeleted)
    {
      this.queAns.filter(x=>x.parentSectionGuid==sectionDeleted.sectionGuid).forEach(x=>{
        x.parentSectionGuid=null;
        x.parentQuestionGuid=null;
        x.parentQuesResponse=null;
      })

    }
    if (this.isEditmode === false) {


      this.queAns.splice(index, 1);

    }
    else if (this.isEditmode === true) {
      this.queAns[index].isDeleted = true;

    }

    let gridControl= new GridQuestion();
    gridControl=this.gridQuestions.filter(x=>x.sequenceNumber==index+1)[0];
    const index1: number = this.gridQuestions.indexOf(gridControl);
    if (index1 !== -1) {
        this.gridQuestions[index1].isDeleted=true;
    }

    this.data.changeMessage(this.queAns);
    this.IncludeEsignConsent();

  }

  toggleEditQuestion(que: Question) {
    que.editQuestion = !que.editQuestion;
  }

  duplicateQuestion(que: Question, questions: Question[]) {

    
    let arr=[];
    questions.forEach(x=>{
     arr.push(x.questionTextShort.substr(2));
    });
    let sorted=arr.sort((a,b)=>a-b);
    let tag = que.questionTextShort.replace(/\d+/g, '') + parseInt(sorted[sorted.length-1])+1;
    //(questions.length + 1);
    let obj: any = JSON.stringify(que);
    obj = JSON.parse(obj);
    obj.questionTextShort = tag;
    obj.editQuestion = false;
    obj.questionId=0;
    obj.questionGuid=this.guid();
    if(questions && questions.length>0)
    {
    let seq=questions.sort((a,b)=>(a.sequenceNumber-b.sequenceNumber));
    obj.sequenceNumber=seq[seq.length-1].sequenceNumber+1;
    }
    questions.push(obj);
    this.data.changeMessage(this.queAns);
  }

  removeItems(items: Question[] | string[], rowNumber: number,card:QuestionAnswer,isGrid:boolean,gridId:number)
  {
    

    if(isGrid)
    {

      let grdControl=card.gridQuestions.find(x=>x.gridId==gridId && x.isDeleted==false) ;
      if(grdControl!=null)
      {
        if (this.isEditmode === false) {
          grdControl.questions.splice(rowNumber, 1);
        }
        else
        {
        grdControl.questions[rowNumber]["isDeleted"]=true
        }
      }
    }
    else
    {
        //delete parent question and response mapping
        let que=items[rowNumber];
        if(que)
        {

          let childQues=card.questions.filter(x=>x.parentQuestionGuid==que["questionGuid"]);
          if(childQues)
          {
            childQues.forEach(element => {
              element.parentQuestionGuid="";
              element.parentQuesResponse="";
            });
          }
          let childSec=this.queAns.filter(x=>x.parentQuestionGuid==que["questionGuid"]);
          if(childSec)
          {
            childSec.forEach(x=>{
              x.parentSectionGuid=null;
              x.parentQuestionGuid=null;
              x.parentQuesResponse=null;
            })
          }
        }
        //

    if (this.isEditmode === false) {
      items.splice(rowNumber, 1);

    }
    else if (this.isEditmode === true) {

      items[rowNumber]["isDeleted"] = true;
    }
    }


    this.data.changeMessage(this.queAns);
    this.IncludeEsignConsent();

  }

  updateData() {
    this.data.changeMessage(this.queAns);
  }

  preview(que: Question, files) {
    if (files.length === 0)
      return;

    let mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    let reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      que.questionImage = reader.result;
      this.data.changeMessage(this.queAns);
    }
  }

  selectOption(que, option, index) {
    if (que.dataType == 'checkbox')
      option.selected = !option.selected;
    else {
      que.options = que.options.map(ele => {
        ele.selected = false
        return ele;
      });
      que.options[index].selected = true;
    }
  }
  
  ConfigureQuestionPeroperty(mappingParentQuesGrid,childobj,index,obj)
  {
 //Here adding index position to save the Questions in sequence manner
        // +1 is added, In DB sequence parameter will not allow 0
        mappingParentQuesGrid.push({"old":childobj.sequenceNumber,"new":index+1});
        let oldSequenceNumber=childobj.sequenceNumber;
        childobj.sequenceNumber = index + 1;
        childobj.inputType = this.pageadapter.getInputTypeonPost(childobj.dataType);
        if(childobj.inputType=="table")
        {
          let grControl=obj.gridQuestions.findIndex(x=>x.sequenceNumber==oldSequenceNumber);
          if(grControl!=-1)
          {
          obj.gridQuestions[grControl].sequenceNumber=childobj.sequenceNumber;
          }

        }
        childobj.dataType = "";
        childobj.refTableName = "Survey Questions";
        if (childobj.isQuestionRequired == null || childobj.isQuestionRequired == "") {
          childobj.isQuestionRequired = "N";
        }
        childobj.editQuestion = false;
        childobj.questionImage = (<string>childobj.questionImage).replace(/^data:image\/(png|jpg|jpeg|svg);base64,/, '');


  }

  //Here D for Draft and S for Publish
  publish(status: string) {
    let cards = [];
    let survey = new CreateSurvey();
    survey.surveyId = this.SurveyId;
    survey.name = this.SurveyName;
    survey.status = status;
    //survey.description = "POST 940";
    survey.sections = this.queAns;

    // let isValid=true;
    // let IsEmptySurvey=false;
    // if(survey.sections.filter(x=>x.isDeleted==false || x.isDeleted==null).length<=0)
    // {
    //   IsEmptySurvey=true;
    // }
    // survey.sections.forEach((obj, parindex) => {

    //   let lstNoOptionType=[];
    //   lstNoOptionType.push('textbox');
    //   lstNoOptionType.push('textarea');
    //   lstNoOptionType.push('signature');
    //   lstNoOptionType.push('fileupload');
    //   lstNoOptionType.push('table');
    //   lstNoOptionType.push('dte');
    //   lstNoOptionType.push('rating');

    //   if(obj.questions.filter(x=>x.isDeleted==false|| x.isDeleted==null).length<=0)
    //   {
    //     IsEmptySurvey=true;
    //   }
    //   else if(obj.sectionName.trim().length<=0)
    //   {
    //     isValid=false;
    //   }
    //   else if(obj.questions.filter(x=>x.questionText.length<=0 ||
    //       ( (lstNoOptionType.indexOf(x.dataType)==-1) &&
    //        x.options.length>0 && x.options.filter(x=>x.value.length<=0).length>0)).length>0 )
    //   {
    //     isValid=false;
    //   }
    //   else if(obj.gridQuestions.length>0
    //     && (obj.gridQuestions.filter(x=> (x.isDeleted==false || x.isDeleted==null )
    //       && x.questions.length<=0 || x.questions.filter(x=>(x.isDeleted==false || x.isDeleted==null)
    //       && (x.questionText.length<=0 ||
    //       ((lstNoOptionType.indexOf(x.dataType)==-1) && x.options.length>0
    //       && x.options.filter(x=>x.value.length<=0).length>0))))
    //        ))
    //       {
    //         isValid=false;
    //       }

    // });
    // if(status != "D" && IsEmptySurvey)
    // {
    //   this.notificationService.showError("Survey should have atleast one section and each section must have atleast one question.", "Survey Publish Failed!");
    //   return;
    // }
    // else if(status != "D" && !isValid)
    // {
    //   this.notificationService.showError("Section title, Question and Options cannot be left blank.", "Survey Publish Failed!");
    //   return;
    // }

    survey.isEsignReq=this.globalSession.GetESignReq();
    survey.eSignConsentText=this.esignConsenttext;
    survey.sections.forEach((obj, parindex) => {


      obj.sequenceNumber = parindex + 1;
      let mappingParentQuesGrid=[];
      obj.questions.forEach((childobj, index) => {
        
        this.ConfigureQuestionPeroperty(mappingParentQuesGrid,childobj,index,obj);
        if(childobj.subQuestions)
        {
          childobj.subQuestions.forEach((x, y)=>{
            this.ConfigureQuestionPeroperty(mappingParentQuesGrid,x,y,obj);
          });
        }

        // if(childobj.questionText.trim().length<=0)
        // {
        //   isValid=false;
        // }
        // else if(childobj.options.length>0 && isValid==true)
        // {
        //   childobj.options.forEach(x=>{
        //     if(x.value.trim().length<=0)
        //     {
        //       isValid=false;
        //     }
        //   })
        // }
        //Here adding index position to save the Questions in sequence manner
        // +1 is added, In DB sequence parameter will not allow 0
        // mappingParentQuesGrid.push({"old":childobj.sequenceNumber,"new":index+1});
        // let oldSequenceNumber=childobj.sequenceNumber;
        // childobj.sequenceNumber = index + 1;
        // childobj.inputType = this.pageadapter.getInputTypeonPost(childobj.dataType);
        // if(childobj.inputType=="table")
        // {
        //   let grControl=obj.gridQuestions.findIndex(x=>x.sequenceNumber==oldSequenceNumber);
        //   if(grControl!=-1)
        //   {
        //   obj.gridQuestions[grControl].sequenceNumber=childobj.sequenceNumber;
        //   }

        // }
        // childobj.dataType = "";
        // childobj.refTableName = "Survey Questions";
        // if (childobj.isQuestionRequired == null || childobj.isQuestionRequired == "") {
        //   childobj.isQuestionRequired = "N";
        // }
        // childobj.editQuestion = false;
        // childobj.questionImage = (<string>childobj.questionImage).replace(/^data:image\/(png|jpg|jpeg|svg);base64,/, '');

      });
      obj.gridQuestions.forEach((gridObj, index) => {

        //Here adding index position to save the Questions in sequence manner
        // +1 is added, In DB sequence parameter will not allow 0

        gridObj.gridId=index+1;

        //gridObj.sequenceNumber = gridObj.sequenceNumber;
        gridObj.questions.forEach((childobj,index)=>{

          // if(childobj.questionText.trim().length<=0)
          // {
          //   isValid=false;
          // }
          // else if(childobj.options.length>0 && isValid==true)
          // {
          //   childobj.options.forEach(x=>{
          //     if(x.value.trim().length<=0)
          //     {
          //       isValid=false;
          //     }
          //   })
          // }

        childobj.inputType = this.pageadapter.getInputTypeonPost(childobj.dataType);
        childobj.dataType = "";
        childobj.refTableName = "Survey Questions";
        if (childobj.isQuestionRequired == null || childobj.isQuestionRequired == "") {
          childobj.isQuestionRequired = "N";
        }
        childobj.editQuestion = false;
        childobj.questionImage = (<string>childobj.questionImage).replace(/^data:image\/(png|jpg|jpeg|svg);base64,/, '');
      });
    });

    });

    //user activity log
    let userActivityObj = this.buildUserActivityOject("Update","Survey");
    survey.userActivityLog = (userActivityObj != null ? userActivityObj : null);

    // this.baseHttpService.post(this.constant.postquestions, JSON.parse(JSON.stringify(survey))).subscribe((dt) => {
    this.baseHttpService.post(this.constant.postquestions, survey).subscribe((dt) => {
      if(dt != null){
        this.cardservice.getSurveyDetails(dt);     
        this.ngOnInit(); // need to change later
      }     
      
      if (status == "D") {
        this.queAns.forEach(obj=>{
          obj.isExpanded = false;
          obj.questions.forEach((obj, index) => {
            obj.dataType = this.pageadapter.getInputTypeonEdit(obj.inputType);
          });
        });

        this.notificationService.showSuccess("Survey has created successfully.", "Survey draft successful!");
        this.hidePopUp = true;
      }
      else {
        
      this.queAns = [];
      this.queTypes = [];
      this.surveyDetails = new CreateSurvey();
        this.notificationService.showSuccess("Survey has published successfully.", "Survey publish successful!");
        this.router.navigate(["/dashboard"]);
      }
    });
  }
  buildUserActivityOject(action :string,actionItem :string) : UserActivityLogModel{   
    let userActivity = new UserActivityLogModel();
    userActivity.action = action;  
    userActivity.actionItem = actionItem;   
    return  userActivity;  
  }
  
  onChangeSubQuesType(event,que,questions)
  {
  //
  let subQueMap=questions.find(x=>x.questionGuid==que.questionGuid);
  let queType=this.queTypes.find(x=>x.type==event);
  if(subQueMap && subQueMap.subQuestions)
  {
    subQueMap.subQuestions.forEach(element => {
//element.subQuestion.dataType=queType.type;
element.dataType=queType.type;

    });
  }
  this.data.changeMessage(this.queAns);

  }
  removeSubQuestion(que,k, option,questions)
  {
    //
   let removeQues=0;
   let subQueMap=questions.find(x=>x.questionGuid==que.questionGuid);
   subQueMap.subQuestions.forEach(element => {
     if(element.sequenceNumber==k )
     {
       if(element.questionId>0)
       element.isDeleted=false;
       else
       removeQues=1;
     }
     if(element.sequenceNumber>k)
     {
     element.sequenceNumber=element.sequenceNumber-1;
     }
   });
   if(removeQues==1)
   subQueMap.subQuestions.splice(k,1);

  }

  addSubQuestion(que,k,option,questions)
  {
    //
    let subQues=new SubQuestion();
    subQues.questionGuid=que.questionGuid;
    //let queType=this.queTypes.find(x=>x.type==que.subQuestions[0].subQuestion.dataType) ;
    let queType=this.queTypes.find(x=>x.type==que.subQuestions[0].dataType) ;

    // subQues.subQuestion=new Question("", queType.icon + que.subQuestions.length, queType.type,this.guid(), que.subQuestions.length);
   let ques=new Question("", queType.icon + que.subQuestions.length, queType.type,this.guid(), que.subQuestions.length);
   ques.isExpanded=false;
   let subQueMap=questions.find(x=>x.questionGuid==que.questionGuid);
    subQueMap.subQuestions.push(ques);

  }
  updateSubQuestionText(que,k, option,questions)
  {
    //
    let subQueMap=questions.find(x=>x.questionGuid==que.questionGuid);

  }


  TempStoreData() {
    let survey = new CreateSurvey();
    survey.surveyId = this.SurveyId;
    survey.name = this.SurveyName;
    survey.sections = [];
    survey.sections=this.queAns;
    return survey;
  }
  close(event) {
    this.hidePopUp = true;
  }
  SaveConf() {
    this.outputToSettingPanel.emit();
    this.isEditing=false;
    this.hidePopUp = false;
  }

  updateRatingConfig(config, que) {
    this.data.changeMessage(this.queAns);
  }

  private guid() {
    return uuidv4();
  }


}



